import { render, staticRenderFns } from "./snackbarCenter.vue?vue&type=template&id=13264adc&scoped=true&"
import script from "./snackbarCenter.vue?vue&type=script&lang=js&"
export * from "./snackbarCenter.vue?vue&type=script&lang=js&"
import style0 from "./snackbarCenter.vue?vue&type=style&index=0&id=13264adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13264adc",
  null
  
)

export default component.exports